<template>
    <svg
        :width="width"
        :height="height"
        :viewBox="`0 0 ${width} ${height}`"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :class="$attrs.class"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            :d="`M${width} 0H${cornerThickness}H0V${cornerThickness}V${height}H${cornerThickness}V${cornerThickness}H${width}V0Z`"
            :fill="color"
        />
    </svg>
</template>

<script>
export default {
    name: 'CustomizableCorner',
    props: {
        color: {
            type: String,
            default: 'blue'
        },
        width: {
            type: [Number, String],
            default: 14
        },
        height: {
            type: [Number, String],
            default: 14
        },
        cornerThickness: {
            type: [Number, String],
            default: 4
        }
    }
}
</script>